import React from "react";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

const MAP = {
    positive: { label: "Positive", cls: "chip-positive", Icon: TrendingUp },
    negative: { label: "Negative", cls: "chip-negative", Icon: TrendingDown },
    neutral:  { label: "Neutral",  cls: "chip-neutral",  Icon: Minus },
};

const SentimentBadge = ({ sentiment = "neutral", size = "md", testId }) => {
    const cfg = MAP[sentiment] || MAP.neutral;
    const { Icon } = cfg;
    const iconSize = size === "sm" ? "w-2.5 h-2.5" : "w-3 h-3";
    return (
        <span
            className={`chip ${cfg.cls}`}
            data-testid={testId || `sentiment-${sentiment}`}
        >
            <Icon className={iconSize} />
            {cfg.label}
        </span>
    );
};

export default SentimentBadge;
